module.exports = __webpack_public_path__ + "static/media/article13.a3d21db2.webp";